import { Shield, Lock, ExternalLink, Info } from 'lucide-react';

interface FooterProps {
  brandName?: string;
  brandTagline?: string;
}

export const Footer = ({ brandName, brandTagline }: FooterProps) => {
  const effectiveBrandName = brandName || 'VerifyPH';
  const effectiveTagline = brandTagline || 'Transparency by the People, for the People';

  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="font-bold text-white mb-3">{effectiveBrandName}</h3>
            <p className="text-sm text-gray-400 mb-4">
              {effectiveTagline}. VerifyPH is a citizen-powered platform for documenting and verifying government-funded projects and public services through evidence-based reporting, moderation, and transparency dashboards.
            </p>
            <a
              href="https://dilg.gov.ph/news/ANTI-EPAL-DRIVE-DILG-Orders-Immediate-Removal-of-Officials-Names-and-Images-from-Government-Projects/NC-2026-1047"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-400 hover:text-blue-300 inline-flex items-center gap-1"
            >
              View DILG Memorandum
              <ExternalLink size={12} />
            </a>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="font-bold text-white mb-3">Legal & Information</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="/about"
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
                >
                  <Info size={14} />
                  About VerifyPH
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
                >
                  <Shield size={14} />
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2"
                >
                  <Lock size={14} />
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="font-bold text-white mb-3">Support</h3>
            <p className="text-sm text-gray-400 mb-2">
              For questions or concerns about the platform, please contact the administrators.
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Made with ❤️ for transparency and accountability
            </p>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="border-t border-gray-800 mt-6 pt-6">
          <p className="text-xs text-gray-400 text-center italic max-w-3xl mx-auto">
            VerifyPH documents citizen-submitted evidence. It does not make legal judgments, accusations, or official determinations.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-6 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <p>
            © {new Date().getFullYear()} {effectiveBrandName} - {effectiveTagline}. All rights
            reserved.
          </p>
          <p>
            Compliant with Data Privacy Act of 2012 (RA 10173)
          </p>
        </div>
      </div>
    </footer>
  );
};
